(() => {
  const allowedHosts = new Set([
    'youtube.com',
    'www.youtube.com',
    'youtube-nocookie.com',
    'www.youtube-nocookie.com'
  ]);

  const createVideoUrl = (source) => {
    try {
      const url = new URL(source.replace(/&amp;/g, '&'), window.location.href);
      if (!allowedHosts.has(url.hostname.toLowerCase()) || !url.pathname.startsWith('/embed/')) {
        return null;
      }
      url.searchParams.set('autoplay', '1');
      return url;
    } catch (error) {
      return null;
    }
  };

  const loadVideo = (trigger) => {
    const wrapper = trigger.closest('[data-kk-product-youtube]');
    if (!wrapper || wrapper.dataset.videoLoaded === 'true') return;

    const videoUrl = createVideoUrl(wrapper.dataset.videoSrc || '');
    if (!videoUrl) return;

    const iframe = document.createElement('iframe');
    iframe.className = 'kk-product-youtube__iframe';
    iframe.src = videoUrl.href;
    iframe.title = wrapper.dataset.videoTitle || trigger.getAttribute('aria-label') || 'YouTube-video';
    iframe.width = wrapper.dataset.videoWidth || '560';
    iframe.height = wrapper.dataset.videoHeight || '315';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('tabindex', '0');

    wrapper.dataset.videoLoaded = 'true';
    wrapper.classList.add('is-loaded');
    trigger.replaceWith(iframe);

    try {
      iframe.focus({ preventScroll: true });
    } catch (error) {
      iframe.focus();
    }
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-kk-product-youtube-trigger]');
    if (trigger) loadVideo(trigger);
  });
})();
